import { render, staticRenderFns } from "./ColumnFooter.vue?vue&type=template&id=104ed4e4&"
import script from "./ColumnFooter.vue?vue&type=script&lang=js&"
export * from "./ColumnFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports